import { useJurisdictionStore } from '@/hooks/use-jurisdiction';

export const useLeagueNavigationEnabled = () =>
    useJurisdictionStore(
        state => state.jurisdictionSettings?.productConfig?.settings?.league_navigation_enabled ?? false
    );
